// dependencies imports ⇒
import React, { useEffect, useState } from "react";
// assets and scss imports ⇒
import "./resourceSelectionView.scss";
import InfoIcon from "../../../assets/infoIconDisabled.svg";

import CustomSelect from "../../UI Component/CustomSelect/CustomSelect";
import SearchBarWithIcon from "../../common/Modules/SearchBarWithIcon";
import RadioButtonWithText from "../../common/Modules/RadioButtonWithText";
import { BOOKING_TYPE, BOOKING_TYPES } from "../Constants";
// project file imports(UI components) ⇒

// const file imports(helper methods, etc) ⇒

const ResourceSelectionView = (props) => {
  const {
    resourceList,
    selectedResource,
    procedureList,
    searchProcedure,
    selectedBookingType,
    addBooking,
    handleResource,
    handleProcedure,
    handleSearchProcedure,
    handleBookingType,
    handleProcedureList,
  } = props;
  // const declarations ⇒

  const [selectedProcedure, setSelectedProcedure] = useState(null);

  useEffect(() => {
    if (!selectedResource.value && procedureList.length > 0) {
      handleProcedureList();
    }
  }, [selectedResource, procedureList]);
  // Handlers
  const onChangeProcedureMobileView = (procedure) => {
    setSelectedProcedure(procedure);
    handleProcedure(procedure);
  };

  // Display UI
  const labelUI = (title, isHeading) => {
    return (
      <div
        className={`resource-selection-view-label ${
          isHeading && "resource-selection-heading"
        }`}
      >
        {title}
      </div>
    );
  };

  const searchbarUI = () => {
    return (
      <div>
        <SearchBarWithIcon
          placeholder="Search Procedure"
          inputCallBack={handleSearchProcedure}
          search_string={searchProcedure}
        />
      </div>
    );
  };

  const selectResourceUI = () => {
    const selectLabel =
      addBooking && selectedBookingType === "Laboratory"
        ? "Resource"
        : "Doctor";
    const message = addBooking ? `Select ${selectLabel}` : "";
    return (
      <div className="select-resource-container">
        {labelUI(addBooking ? "Account" : "Resource")}
        <CustomSelect
          showSearch={true}
          isSearchable={false}
          options={resourceList}
          placeholder={message}
          seacrhbarPlaceholder={
            addBooking && selectedBookingType === BOOKING_TYPE.CLINIC
              ? "Search Doctor"
              : "Search Resource"
          }
          value={selectedResource?.value ? selectedResource : ""}
          handleChange={handleResource}
        />
        {selectedResource?.common_procedure && singleSlotMessageUI()}
      </div>
    );
  };

  const selectProcedureUIMobileView = () => {
    const options = procedureList?.map((item) => ({
      ...item,
      name: item?.procedure_name,
      value: item?.procedure_name,
      label: item?.procedure_name,
    }));
    return (
      <>
        <CustomSelect
          showSearch={true}
          isSearchable={false}
          options={options}
          placeholder={`Search Procedure`}
          seacrhbarPlaceholder={`Search Procedure`}
          value={selectedProcedure}
          handleChange={(procedure) => {
            onChangeProcedureMobileView(procedure);
          }}
        />
      </>
    );
  };

  const selectProcedureUI = () => {
    return (
      <div className="select-procedure-container">
        {labelUI("Procedure")}
        {window.innerWidth > 768 ? (
          <>
            {searchbarUI()}
            {procedureListUI()}
          </>
        ) : (
          <>{selectProcedureUIMobileView()}</>
        )}
      </div>
    );
  };

  const procedureListUI = () => {
    return (
      <div className="procedure-list-container">
        {procedureList.map((procedure, index) => (
          <div
            className="procedure-list-item"
            key={index}
            onClick={() => handleProcedure(procedure)}
          >
            <i
              class={
                "fa fa-check check-icon " +
                (procedure?.selected ? "active-check" : "")
              }
              aria-hidden="true"
            ></i>
            {procedure.procedure_name}
          </div>
        ))}
      </div>
    );
  };

  const singleSlotMessageUI = () => {
    return (
      <div className="single-slot-message-container">
        <div className="single-slot-info-icon">
          <img src={InfoIcon} alt="" />
        </div>
        <div className="single-slot-message-text">
          One time slot can be used for booking various procedures under this
          resource
        </div>
      </div>
    );
  };

  const resourceSelectionViewUI = () => {
    return (
      <>
        {selectResourceUI()}
        {selectProcedureUI()}
      </>
    );
  };

  const bookingTypeRaidoButtonUI = () => {
    return (
      <>
        <div>
          {labelUI("Booking Type", true)}
          <div className="booking-type-list">
            {BOOKING_TYPES.map((type, index) => (
              <div key={index} className="booking-type">
                <RadioButtonWithText
                  data={type}
                  text={type.label}
                  value={type.value}
                  selected={type.value === selectedBookingType}
                  handleChange={() => handleBookingType(type)}
                />
              </div>
            ))}
          </div>
        </div>
        <hr className="rsvc-hr" />
      </>
    );
  };

  return (
    <div className="resource-selection-view-container">
      {addBooking && bookingTypeRaidoButtonUI()}
      {resourceSelectionViewUI()}
    </div>
  );
};

//export
export default ResourceSelectionView;
